import Link from 'next/link';
import Avatar from 'components/common/Avatar';
import { AvatarData } from 'components/common/Avatar';
import styles from './UserButton.module.css';
import { getCommunityProfilePageUrl } from 'lib/community';

const UserButton = <T extends AvatarData>({
  data,
  className,
}: {
  data: T;
  className?: string;
}) => {
  return (
    <div className={className}>
      <Link href={getCommunityProfilePageUrl(data.username!)}>
        <button className={styles.User}>
          <div className={styles.Avatar}>
            <Avatar data={data} fontSize={14} />
          </div>
          <h4>{data.username}</h4>
          {data.isForHire && (
            <div className={styles.ForHireBadge}>For Hire</div>
          )}
        </button>
      </Link>
    </div>
  );
};

export default UserButton;
